<template>
<div class="patrolItem">
   <el-drawer :title="drawerTitle" :size="drawerWidth" :modal="false" :visible.sync="drawerShow" @close="closeMess" :wrapperClosable="false" direction="rtl" ref="drawer">
      <patrol-item-drawer v-if="drawerShow" :loading.sync="loading" :parentData="parentData" :editData="editData" :handleType="handleType" :templateName="templateName" @confirm="handleConfirm" @cancel="handleCancel"></patrol-item-drawer>
   </el-drawer>
   <div class="mainContent" :style="styleObject">
      <div class="query">
         <span>
            <el-select v-model="params.likeKey" placeholder="请选择" @change="selectChange" clearable>
               <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <el-input v-model="params.likeValue" autocomplete="off" :placeholder="'请输入'+title"></el-input>
            <button class="primaryBtn" v-if="rolePermit('polling:item:query')" @click="loadTable">查询</button>
         </span>
         <button class="primaryBtn" v-if="rolePermit('polling:item:add')" @click="addClick">新增巡检项</button>
      </div>
      <border-table :tableData="dataList" :pageSizes="[10, 20, 50]" :pages="pagination" :loading="tableLoading" :current-page="pagination.page" @currentChange="handleRoleCurrentChange" @sizeChange="handleRoleSizeChange">
         <el-table-column type="index" width="55" label="序号"></el-table-column>
         <el-table-column prop="" label="巡检设备类型"  width="150" show-overflow-tooltip>
            <template slot-scope="scope">
               <div>{{scope.row.typeName}}</div>
            </template>
         </el-table-column>
<!--          <el-table-column prop="" label="巡检项名称"  width="150" show-overflow-tooltip>
           <template slot-scope="scope">
               <div v-for="(item,index) in scope.row.itemDetail" :key="index">
                 <span>{{item.title}}</span>               
                </div>
            </template>
         </el-table-column> -->
         <el-table-column prop="" label="巡检内容">
            <template slot-scope="scope">
               <div v-for="(item,index) in scope.row.itemDetail" :key="index" style="overflow:hidden;">
                 <span style="float:left;">{{item.content}}</span>
                 <span style="float:right;" v-if="rolePermit('polling:item:edit')||rolePermit('polling:item:del')">
                   <el-button v-if="rolePermit('polling:item:edit')" @click="editClick(scope.row,item)" size="small" class="edit">编辑</el-button>
                  <el-button v-if="rolePermit('polling:item:del')" @click="delClick(item)" size="small" class="del">删除</el-button>
                 </span>                 
                </div>
            </template>
         </el-table-column>
      </border-table>
   </div>
</div>
</template>

<script>
import BorderTable from "@/components/common/BorderTable";
import PatrolItemDrawer from "@/components/patrolManagement/PatrolItemDrawer";

export default {
  components: {
    BorderTable,
    PatrolItemDrawer
  },
  data() {
    return {
      params: {
        likeKey: "",
        likeValue: "",
        tenantId: "123456"
      },
      options: [
        {
          value:'typeName',
          label:'巡检设备类型'
        },
        // {
        //   value:'title',
        //   label:'巡检项标题'
        // },
        {
          value:'content',
          label:'巡检内容'
        }
      ],
      dataList: [],
      templateName: "", //选择行的模板名
      styleObject: {
        height: ""
      },
      tableLoading: false,
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      drawerShow: false,
      handleType: "",
      drawerTitle: "",
      drawerWidth: "500px",
      title:"内容",
      id:null,
      editData:{},
      parentData:{}
    };
  },
  created() {
    this.makeheight()
  },
  mounted() {
    this.loadTable();
  },
  methods: {
    //查询
    loadTable() {
      let params = Object.assign({}, this.params);
      params.page = this.pagination.currentPage;
      params.pageSize = this.pagination.pageSize;
      this.dataList = [];
      this.request
        .post("/front/polling/type/getTypeItemPageListInfo", params)
        .then(res => {
          console.log(res);
          
          if (res.code == 200) {
            this.dataList = res.data.pageData;
            this.pagination.total = res.data.total;
          } else {
            this.pagination = {
              show: true,
              currentPage: 1,
              pageSize: 10,
              total: 0
            };
          }
        })
        .catch(error => console.log(error));
    },
    //表格当前页变化时
    handleRoleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.loadTable();
    },
    //表格展示条数变化时
    handleRoleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
      this.loadTable();
    },
        //新增
    addClick(type) {
      this.drawerShow = true;
      this.drawerTitle = "新增巡检项";
      this.handleType = "add";
      this.templateName = "";
      this.$store.commit("saveCurrDbSource", "新增巡检项");
    },
    //编辑
    editClick(data,row) {
      console.log(row);
      this.id=row.id
      this.editData=row
      this.parentData=data
      this.drawerShow = true;
      this.drawerTitle = "编辑巡检项";
      this.handleType = "edit";
      this.templateName = row.name;
      this.$store.commit("saveCurrDbSource", "编辑巡检项");
    },
    //删除
    delClick(row) {
      this.$confirm("此操作将永久删除该巡检项, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
        .then(() => {
          this.request
            .delete("/front/polling/item/delById", {
              id: row.id
            })
            .then(res => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
                let num = ''
               if (this.pagination.total > 1) {
                  num = (this.pagination.total - 1) % this.pagination.pageSize
                  if (num == 0) {
                    if(this.pagination.currentPage>1){
                      this.pagination.currentPage = this.pagination.currentPage - 1
                    }
                  }
               }
                this.loadTable();
              } else if (res.code == 500) {
                this.msg.warn(res.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //关闭抽屉
    closeMess() {
      this.loading = false;
    },
    //确认
    handleConfirm(data) {
      console.log(data)
      if(this.handleType=='add'){
        //保存页面巡检项信息
        let param = Object.assign(data,{tenantId:'123456'})
        this.request
          .post("/front/polling/item/add", param)
          .then(res => {
            if (res.code == 200) {
              this.msg.success("添加成功");
            } else {
              this.msg.warn("添加失败");
            }
            this.loadTable();
          })
          .catch(error => {
            console.log(error);
          });
      }else if(this.handleType=='edit'){
        let params = Object.assign(data,{id:this.id})
        //修改页面巡检项信息
        this.request
          .post("/front/polling/item/updateItemByTypeId", params)
          .then(res => {
            if (res.code == 200) {
              this.msg.success("修改成功");
            } else {
              this.msg.warn("修改失败");
            }
            this.loadTable();
          })
          .catch(error => {
            console.log(error);
          });
      }
      this.drawerShow = false;
    },
    //取消
    handleCancel(data) {
      console.log(data);
      this.drawerShow = false;
    },
    selectChange(data){
      console.log(data);
      this.title=(data=='typeName'?'巡检设备类型':data=='title'?'巡检项标题':data=='content'?'巡检内容':'内容')
    },
     //动态获取中间滚动高度,'height'为头部和尾部的高度之和
    makeheight(height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
  }
};
</script>

<style lang="scss" scoped>
.patrolItem {
  .query {
    margin-bottom: 20px;
  }

  .topTabs {
    height: 40px;
    background: #fff;
  }

  .mainContent {
    margin: 12px;
    padding: 15px 20px;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;

    .edit {
      background: #327ae6;
      color: #fff;
    }

    .del {
      background: #eaa13a;
      color: #fff;
    }
  }
}
</style><style lang="scss">
.patrolItem {
  .query {
    .el-input {
      width:240px;
      margin-right: 10px;

      .el-input__inner {
        line-height: 36px;
        height: 36px;
      }
    }

    .el-select {
      width: 180px;
      margin-right: 10px;

      .el-input {
        width: 180px;
        margin-right: 10px;

        .el-input__inner {
          line-height: 36px;
          height: 36px;
        }
      }
    }

    .el-radio.is-checked .el-radio__input.is-checked .el-radio__inner {
      border-color: #42bced;
      background: #42bced;
    }

    .el-radio.is-checked .el-radio__label {
      color: #147dd9 !important;
    }
  }
}
</style>
